// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__lmPfW","actionsCol":"EnrolledClinics_actionsCol__3Z5Gv"};